import UltMeta, { Meta } from "./UltMeta/index";

// 会员等级定义

/**
 * 会员等级枚举
 */
class Level extends UltMeta {
    PENDING = new Meta(1, "非会员", "非会员");
    BASE = new Meta(2, "基础会员", "砂价运价无限制查看");
    SENIOR = new Meta(3, "高级会员", "AI助理无限制");
}

export const LEVEL = new Level();

/**
 * 会员状态
 */
class openState extends UltMeta {
    /** 关闭 */
    CLOSE = new Meta(0, "关闭");
    /** 开放 */
    OPEN = new Meta(1, "开放");
}
/** 会员状态 */
export const OPEN_STATE = new openState();

/**
 * 购买类型
 */
class BuyType extends UltMeta {
    MONTH = new Meta(1, "按月付");
    YEAR = new Meta(2, "按年付");
}

export const BUY_TYPE = new BuyType();
